import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import CentralMappingMappingEntry from 'lumen/models/central-mapping/mapping-entry';

export default class CentralMappingMappingEntryDayOfWeek extends CentralMappingMappingEntry {
  // @ts-expect-error: Class inheritance
  [Type] = 'central-mapping/mapping-entry-day-of-week' as const;

  // Stores the weekday number value received from the backend,
  // as `value` contains the translated representation of this weekday number.
  @attr('string') declare rawValue: string;
}
